import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

export class ConfirmationWindowComponentData {
  title?: string;
  message?: string;
  projectDataText?: string;
  hideClose?: boolean;
}

@Component({
  selector: 'app-confirmation-window',
  templateUrl: './confirmation-window.component.html',
  styleUrls: ['./confirmation-window.component.scss']
})
export class ConfirmationWindowComponent {
  title: string;
  message: string;
  hideClose = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ConfirmationWindowComponentData,
    public dialogRef: MatDialogRef<ConfirmationWindowComponent>,
    private translate: TranslateService
  ) {
    if (!data.message) {
      this.translate.get('unsaved_data_title', {data: data.projectDataText}).subscribe(translated => {
        this.title = translated;
      });
      this.translate.get('unsaved_data_message').subscribe(translated => {
        this.message = translated;
      });
    } else {
      this.message = this.data.message;
    }
    if (data.hideClose) {
      this.hideClose = data.hideClose;
    }
  }

  confirm() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close(false);
  }
}
